module.exports = __webpack_public_path__ + "f5107e4d7d61b7f1e41df984aa47107d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-rosario.png
// module id = 1543
// module chunks = 0